import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createPostgresqlProject } from '@/enteties/postgresql/api';
import type { CreatePostgresProject } from '@/enteties/postgresql/model';
import { useState } from 'react';
import { projectKeys } from '@/enteties/project/api/projects.query-key';
import { useApiStatusToast } from '@/shared/hooks/useApiStatusToast';
import * as m from '@paraglide/messages';

export const useCreateCnpg = (
  onSuccess: () => void,
  goToStepAndSetError: (
    step: 'tariff' | 'service-type',
    name: string,
    error: string
  ) => void
) => {
  const [timedOut, setTimedOut] = useState(false);
  const [_, error] = useApiStatusToast();
  const queryClient = useQueryClient();
  const cnpgMut = useMutation({
    onMutate: () => {
      setTimedOut(true);
    },
    mutationFn: (data: CreatePostgresProject) => createPostgresqlProject(data),
    onSuccess: () => {
      setTimeout(async () => {
        onSuccess();
        await queryClient.invalidateQueries({
          queryKey: projectKeys.allProjects,
        });
        setTimedOut(false);
      }, 7000);
    },
    onError: (err: Error) => {
      setTimedOut(false);
      if (err.message.startsWith('409')) {
        goToStepAndSetError('tariff', 'name', m.create_dialog_step_error_409());
      }
      error({
        description: `${err.message}`,
      });
    },
  });

  return { timedOut, ...cnpgMut };
};
